import { render, staticRenderFns } from "./BloqueioHorarioEspecificoConfiguracao.vue?vue&type=template&id=4dfeae94&scoped=true"
import script from "./BloqueioHorarioEspecificoConfiguracao.vue?vue&type=script&lang=ts"
export * from "./BloqueioHorarioEspecificoConfiguracao.vue?vue&type=script&lang=ts"
import style0 from "./BloqueioHorarioEspecificoConfiguracao.vue?vue&type=style&index=0&id=4dfeae94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfeae94",
  null
  
)

export default component.exports